import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const startRecipientRequestVerificationApi = (
  token: string,
  mobilePhone: string
): Promise<ApiResponseType<{ session_id: string; status: string; phone_masked: string }>> =>
  apiService.POST(`/recipient-requests/${token}/verify/start/`, { mobile_phone: mobilePhone });
